import { baseConfig } from "config";
import { store } from "store";
import { setFirstAcess } from "store/features/flags/slice";
import { resetRegistration } from "store/features/registration/slice";
import {
	setAccessToken,
	setFcm,
	setLoggedUser,
	setLogout,
	setTokens
} from "store/features/tokens/slice";
import { SelfRegisterTokens } from "store/features/tokens/types";
import { requestFirebaseNotificationPermission } from "../firebase/firebase-messaging";
import { updatePartnerFcmToken } from "./partner";
import { Requester } from "./requester";

export const getAccessToken = async () => {
	const { access, refresh, partner_uuid, fcm_token } = store.getState().tokens;
	// logout
	if (!access) {
		if (refresh) {
			try {
				const newAccess = await renewAccessToken();
				return newAccess;
			} catch (error) {
				store.dispatch(setLogout());
				store.dispatch(resetRegistration());
				window.location.href = "/login";
				return null;
			}
		}
		store.dispatch(setLogout());
		store.dispatch(resetRegistration());
		window.location.href = "/login";
		return null;
	}

	if (fcm_token) {
		requestFirebaseNotificationPermission().then(async (currentToken) => {
			if (currentToken && currentToken !== fcm_token) {
				store.dispatch(setFcm(currentToken));
				await updatePartnerFcmToken(access, partner_uuid, currentToken);
			}
		});
	}
	return access;
};

export const renewAccessToken = async () => {
	const { refresh } = store.getState().tokens;
	const response = await fetch(`${baseConfig.baseURL}/auth/token/refresh/`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify({
			refresh
		})
	});
	if (response.status === 401) {
		throw new Error("Refresh token inválido ou expirado");
	}

	const parsedResponse = await response.json();
	if (!parsedResponse.access) {
		throw new Error("Não foi possível renovar o token");
	}
	store.dispatch(setAccessToken(parsedResponse.access));
	return parsedResponse.access;
};

export const resetAppPassword = async (
	token: string,
	email: string,
	password: string,
	passwordConfirmation: string
) => {
	return Requester.put({
		url: `${baseConfig.baseURL}/auth/change-password/${token}/`,
		body: {
			email,
			new_password: password,
			new_password_confirm: passwordConfirmation
		},
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const changeAppPassword = async (
	old_password: string,
	new_password: string,
	new_password_confirm: string
) => {
	const access_token = await getAccessToken();
	return Requester.put({
		url: `${baseConfig.baseURL}/auth/change-password/`,
		token: access_token,
		tokenType: "Bearer",
		body: {
			old_password,
			new_password,
			new_password_confirm
		},
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const createOrUpdatePartnerAccount = async (
	loggedUser: any,
	email: string,
	phone: string,
	password: string,
	passwordConfirmation: string
) => {
	if (!loggedUser) {
		return Requester.post({
			url: `${baseConfig.baseURL}/auth/register/`,
			body: {
				email,
				phone,
				password,
				password2: passwordConfirmation
			},
			success: (result): SelfRegisterTokens => {
				store.dispatch(setTokens(result));
				return result;
			},
			error: (error) => {
				throw error;
			}
		});
	}

	return loggedUser;

	/*
	return Requester.put({
		url: `${baseConfig.baseURL}/auth/register/`,
		body: {
			email,
			phone,
			password,
			password2: passwordConfirmation
		},
		success: (result): SelfRegisterTokens => {
			store.dispatch(setTokens(result));
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
	*/
};

export const partnerLogin = async (username: string, password: string) => {
	return Requester.post({
		url: `${baseConfig.baseURL}/auth/token/`,
		body: {
			username,
			password
		},
		success: (result): SelfRegisterTokens => {
			store.dispatch(setTokens(result));
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getPartnerUuid = async () => {
	const access_token = await getAccessToken();
	return Requester.get({
		url: `${baseConfig.baseURL}/auth/user/retrieve-self`,
		token: access_token,
		tokenType: "Bearer",
		success: (result): string | null => {
			if (result.client_id) {
				store.dispatch(setLogout());
				store.dispatch(resetRegistration());
				throw new Error("Prestador não encontrado");
			}
			store.dispatch(setFirstAcess(false));
			store.dispatch(setLoggedUser(result));
			return result.partner_id;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const requestPasswordReset = async (email: string) => {
	return Requester.post({
		url: `${baseConfig.baseURL}/auth/trigger-reset-password/`,
		body: {
			email
		},
		success: (result) => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const logout = async () => {
	store.dispatch(setLogout());
	store.dispatch(resetRegistration());
};
